import { Component } from '@angular/core';
import { FormsModule, Validators, NgForm } from '@angular/forms';
import { AgencyService } from '../_Services/agency.service';
import { Router, ActivatedRoute } from '@angular/router'; 

@Component({
  templateUrl: 'addagentpic.component.html' 
})
export class AddagentpicComponent {

  	model: any = {};
    responseStatus:Object= [];
    status:boolean;
    agency_id: Number;
    error = '';

	constructor(private router: Router, private route:ActivatedRoute, private agencyService: AgencyService) { }

	onSubmit() {
		console.log(this.model);
		this.agencyService.addAgencyPic(this.model, this.agency_id).subscribe(result => {
            if (result.status === true) {
                this.router.navigate(['/agencies/addagentceo/' + result.agency_id]);
            } else {
                this.error = 'Username or password is incorrect'; 
            }
        }); 
	}

	ngOnInit() { 
	    this.agency_id = this.route.snapshot.params['id'];
	}

}



// WEBPACK FOOTER //
// ./src/app/repoagencies/addagentpic.component.ts